import React, { useEffect, useState } from "react";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { appConstantes, nemonicoOrganoControl } from "../../constantes/appConstantes";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { obtenerCargoControl, setListaCargoControl } from "../../sliceRedux/ValidarReserva.slice";

const RegistrarCargo = (props) => {
  const {
    modal,
    callbackModal,
    showLoader,
    hideLoader,
    dispatch,
    callbackSelected,
    cargo,
    codSolConstitucion,
    codGrupoConstAdec,
    listaExcluir,
  } = props;
  const listaCargoControl = useSelector((state) => state.validar.listaCargoControl);
  const [bandejaCargos, setBandejaCargos] = useState([]);

  useEffect(() => {
    showLoader();
    let dataSend = {
      nemTipoGobierno: cargo.nemCatTipoGobierno,
      grupoConstAdec: codGrupoConstAdec,
      codSolicitud: codSolConstitucion,
      nemTipoCargo: nemonicoOrganoControl.CARGO_DIRECTIVO,
      codParamCargoGrupSoc: cargo.codParamCargoGrupSoc,
    };
    Promise.all([dispatch(obtenerCargoControl(dataSend))]).then(() => {
      hideLoader();
    });
  }, []);

  useEffect(() => {
    if (listaCargoControl.code === 200) {
      let listado = listaCargoControl?.object ?? [];
      listado = listado.filter((item) => !listaExcluir.includes(item.codParamGrupoCargo));
      setBandejaCargos(listado);
    }
    return () => {
      dispatch(setListaCargoControl({ ...listaCargoControl, ...{ code: 0 } }));
    };
  }, [listaCargoControl.code]);

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const validationSchemaEntidad = Yup.object().shape({
    cargoDirectivo: Yup.string().required("Campo requerido."),
  });

  const formik = useFormik({
    initialValues: {
      tipoIdentificacion: cargo.nomCatTipoIdentificacion ?? "",
      identificacion: cargo.numIdentificacion ?? "",
      nombre: cargo.nombres ?? "",
      cargoDirectivo: cargo.codParamCargoGrupSocDirectv ?? "",
      nomCargo: cargo.nomCatCargoDirectv ?? "",
    },
    validationSchema: validationSchemaEntidad,
    onSubmit: (data) => {
      let dataSend = {
        codParamCargoGrupSocDirectv: data.cargoDirectivo,
        nomCatCargoDirectv: data.nomCargo,
      };
      callbackSelected(dataSend);
    },
  });

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  const onClickClose = () => {
    formik.resetForm();
    callbackModal();
  };
  return (
    <>
      <Dialog
        visible={modal}
        header={
          cargo.tipo === nemonicoOrganoControl.GOB_DIRECTIVO
            ? "Asignar cargo órgano directivo"
            : "Asignar cargo órgano de control"
        }
        modal
        resizable={false}
        onHide={onClickClose}
      >
        <div className="flex col-12 md:col-12 ">
          <span className="mr-2" style={{ minWidth: "130px", textAlign: "left" }}>
            Tipo de identificación:
          </span>
          <div className="font-medium">{formik.values.tipoIdentificacion}</div>
        </div>
        <div className="flex col-12 md:col-12 ">
          <span
            htmlFor="identificacion"
            className="mr-2"
            style={{ minWidth: "130px", textAlign: "left" }}
          >
            Identificación:
          </span>
          <div className="font-medium">{formik.values.identificacion}</div>
        </div>
        <div className="col-12 md:col-12 ">
          <span className="mr-4">Apellidos y nombres:</span>
          <span className="font-medium">{formik.values.nombre}</span>
        </div>
        <div className="col-12 md:col-12 ">
          <label
            htmlFor="cargoDirectivo"
            className="mr-2"
            style={{ minWidth: "100px", textAlign: "left" }}
            required
          >
            Directiva:
          </label>
          <div className="col">
            <Dropdown
              id="cargoDirectivo"
              name="cargoDirectivo"
              optionLabel="nomCatCargo"
              optionValue="codParamGrupoCargo"
              value={formik.values.cargoDirectivo}
              options={bandejaCargos}
              emptyMessage={appConstantes.SIN_DATOS}
              className={classNames({
                "p-invalid": isFormFieldValid("cargoDirectivo"),
              })}
              onChange={(e) => {
                let tipo = bandejaCargos?.find((item) => item.codParamGrupoCargo === e.value);
                formik.setFieldValue("nomCargo", tipo?.nomCatCargo ?? "");
                formik.handleChange(e);
              }}
              style={{ width: "100%" }}
            />
            {getFormErrorMessage("cargoDirectivo")}
          </div>
        </div>

        <div className="flex pt-4 justify-content-end">
          <Button
            type="button"
            label="Cerrar"
            onClick={onClickClose}
            icon="pi pi-times-circle"
            className="mr-2"
          />
          <Button
            type="button"
            label="Asignar"
            onClick={formik.handleSubmit}
            icon="pi pi-save"
            className="mr-2"
          />
        </div>
      </Dialog>
    </>
  );
};
export default RegistrarCargo;
